"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SuggestionsComponent = exports.SelectedValuesComponent = exports.findItemByValue = exports.textCrop = exports.isValidItem = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _ChipGroup = _interopRequireDefault(require("../ChipGroup"));

var _Chip = _interopRequireDefault(require("../Chip"));

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _FormControlIcon = _interopRequireDefault(require("../FormControlIcon"));

var _FormControlContent = _interopRequireDefault(require("../FormControlContent"));

var _DropdownMenu = _interopRequireDefault(require("../DropdownMenu"));

var _DropdownMenuItem = _interopRequireDefault(require("../DropdownMenuItem"));

var _DropdownMenuHeader = _interopRequireDefault(require("../DropdownMenuHeader"));

var _DropdownMenuContent = _interopRequireDefault(require("../DropdownMenuContent"));

var _DropdownMenuSearchbar = _interopRequireDefault(require("../DropdownMenuSearchbar"));

var _this = void 0;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var isValidItem = function isValidItem(item) {
  if (!item) {
    return false;
  }

  if (_typeof(item) !== 'object') {
    return false;
  }

  return item.label && item.value;
};

exports.isValidItem = isValidItem;

var textCrop = function textCrop(text) {
  if (text && text.length > 10) {
    return text.substring(0, 7) + '...';
  }

  return text;
};

exports.textCrop = textCrop;

var findItemByValue = function findItemByValue(items, value) {
  var index = -1;

  for (var i = 0; i < items.length; i++) {
    if (items[i].value === value) {
      index = i;
      break;
    }
  }

  return index;
};

exports.findItemByValue = findItemByValue;

var SelectedValuesComponent = function SelectedValuesComponent(_ref) {
  var inputValue = _ref.inputValue,
      value = _ref.value,
      onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      onMenuOpen = _ref.onMenuOpen,
      onMenuClose = _ref.onMenuClose,
      onInputValueChange = _ref.onInputValueChange,
      onSelectItemOn = _ref.onSelectItemOn,
      onSelectItemOff = _ref.onSelectItemOff,
      props = _objectWithoutProperties(_ref, ["inputValue", "value", "onSubmit", "onCancel", "onMenuOpen", "onMenuClose", "onInputValueChange", "onSelectItemOn", "onSelectItemOff"]);

  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === 'Enter') {
      if (onSubmit) onSubmit(e);
    }

    if (e.key === 'Escape') {
      if (onCancel) onCancel(e);
    }
  };

  var renderSelectedItems = function renderSelectedItems() {
    var max = 3;
    return /*#__PURE__*/_react["default"].createElement(_ChipGroup["default"], {
      style: {
        display: 'flex'
      }
    }, value.slice(0, max - 1).map(function (item) {
      return /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
        key: item.value,
        color: "primary",
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
        color: "primary",
        size: "small",
        onClick: onSelectItemOff.bind(_this, item)
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "fas fa-times-circle"
      })), textCrop(item.label));
    }), value.length > max && /*#__PURE__*/_react["default"].createElement(_Chip["default"], {
      color: "primary",
      size: "small",
      disabled: true
    }, "+", value.length - max));
  };

  var renderContent = function renderContent() {
    if (value.length === 0) {
      return /*#__PURE__*/_react["default"].createElement("input", {
        type: "text",
        autoComplete: "off",
        className: "pui-form-control__input",
        placeholder: "Filtrar cole\xE7\xF5es",
        value: inputValue,
        onChange: onInputValueChange,
        onKeyUp: handleKeyUp
      });
    }

    return renderSelectedItems();
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormControlIcon["default"], {
    align: "left"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-filter"
  })), /*#__PURE__*/_react["default"].createElement(_FormControlContent["default"], null, renderContent()), /*#__PURE__*/_react["default"].createElement(_FormControlIcon["default"], {
    align: "right"
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    color: "primary",
    size: "small",
    onClick: onMenuOpen
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-caret-down"
  }))));
};

exports.SelectedValuesComponent = SelectedValuesComponent;
SelectedValuesComponent.defaultProps = {
  onSelectItemOn: function onSelectItemOn() {},
  onSelectItemOff: function onSelectItemOff() {}
};

var SuggestionsComponent = function SuggestionsComponent(_ref2) {
  var value = _ref2.value,
      inputValue = _ref2.inputValue,
      results = _ref2.results,
      onCreate = _ref2.onCreate,
      onMenuOpen = _ref2.onMenuOpen,
      onMenuClose = _ref2.onMenuClose,
      onSelectItemOn = _ref2.onSelectItemOn,
      onSelectItemOff = _ref2.onSelectItemOff,
      onInputValueChange = _ref2.onInputValueChange,
      props = _objectWithoutProperties(_ref2, ["value", "inputValue", "results", "onCreate", "onMenuOpen", "onMenuClose", "onSelectItemOn", "onSelectItemOff", "onInputValueChange"]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, value.length > 0 && /*#__PURE__*/_react["default"].createElement(_DropdownMenuSearchbar["default"], null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    size: "small",
    withMargin: true,
    noBorder: true
  }, /*#__PURE__*/_react["default"].createElement(_FormControlIcon["default"], {
    align: "left"
  }, /*#__PURE__*/_react["default"].createElement("i", {
    className: "fas fa-search"
  })), /*#__PURE__*/_react["default"].createElement("input", {
    type: "text",
    autoComplete: "off",
    className: "pui-form-control__input",
    placeholder: "Pesquisar",
    value: inputValue,
    onChange: onInputValueChange
  }))), /*#__PURE__*/_react["default"].createElement(_DropdownMenuHeader["default"], null, /*#__PURE__*/_react["default"].createElement("span", null, results.count === 0 && 'Nada encontrado', results.count === 1 && 'Um resultado encontrado', results.count > 1 && "".concat(results.count, " resultados encontrados")), inputValue.length > 0 && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    variant: "text",
    tabIndex: "2",
    onClick: onCreate.bind(_this, inputValue)
  }, "Criar item \"", /*#__PURE__*/_react["default"].createElement("strong", null, inputValue), "\"")), results.count > 0 && /*#__PURE__*/_react["default"].createElement(_DropdownMenuContent["default"], null, results.edges.map(function (item) {
    return /*#__PURE__*/_react["default"].createElement(_DropdownMenuItem["default"], {
      tabIndex: "3",
      key: item.value,
      active: findItemByValue(value, item.value) !== -1,
      onClick: onSelectItemOn.bind(_this, item)
    }, /*#__PURE__*/_react["default"].createElement("span", null, item.label));
  })));
};

exports.SuggestionsComponent = SuggestionsComponent;
SuggestionsComponent.defaultProps = {
  onCreate: function onCreate() {},
  onSelectItemOn: function onSelectItemOn() {},
  onSelectItemOff: function onSelectItemOff() {},
  onInputValueChange: function onInputValueChange() {}
};

var Autocomplete = function Autocomplete(_ref3) {
  var inputValue = _ref3.inputValue,
      value = _ref3.value,
      expanded = _ref3.expanded,
      results = _ref3.results,
      onInputValueChange = _ref3.onInputValueChange,
      onSubmit = _ref3.onSubmit,
      onCreate = _ref3.onCreate,
      onCancel = _ref3.onCancel,
      onChange = _ref3.onChange,
      onMenuOpen = _ref3.onMenuOpen,
      onMenuClose = _ref3.onMenuClose,
      itemLabel = _ref3.itemLabel,
      SelectedValuesComponent = _ref3.SelectedValuesComponent,
      SuggestionsComponent = _ref3.SuggestionsComponent,
      props = _objectWithoutProperties(_ref3, ["inputValue", "value", "expanded", "results", "onInputValueChange", "onSubmit", "onCreate", "onCancel", "onChange", "onMenuOpen", "onMenuClose", "itemLabel", "SelectedValuesComponent", "SuggestionsComponent"]);

  if (!value) {
    value = []; // array of { label: '', value: '' }
  }

  if (!results) {
    results = {
      count: 0,
      edges: []
    };
  }

  var inputRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  (0, _react.useEffect)(function () {
    setWidth(inputRef && inputRef.current && inputRef.current.offsetWidth ? "".concat(inputRef.current.offsetWidth, "px") : '');
  }, [inputRef]);

  if (!itemLabel) {
    itemLabel = function itemLabel(value) {
      return value.toString();
    };
  }
  /**
   * Marks an option as selected
   * @param {Object} item 
   * @param {Event} e (optional)
   */


  var handleSelectItemOn = function handleSelectItemOn(item, e) {
    if (value.indexOf(item) !== -1) {
      return;
    }

    var updatedValue = _toConsumableArray(value);

    updatedValue.push(item);
    if (onChange) onChange(updatedValue, e);
  };
  /**
   * Unmarks on option as selected
   * @param {Object} item 
   * @param {Event} e (optional)
   */


  var handleSelectItemOff = function handleSelectItemOff(item, e) {
    console.log('select off', item);
    var index = value.indexOf(item);

    if (index === -1) {
      return;
    }

    var updatedValue = _toConsumableArray(value);

    updatedValue.splice(index, 1);
    if (onChange) onChange(updatedValue, e);
  };

  var handleInputValueChange = function handleInputValueChange(e) {
    if (onInputValueChange) {
      onInputValueChange(e.target.value);
    }
  };

  var isOpen = Boolean(expanded) || inputValue && inputValue.length > 0;
  return /*#__PURE__*/_react["default"].createElement("div", props, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
    ref: inputRef,
    color: "primary",
    hasDropdown: isOpen,
    noBorder: true,
    withMargin: false
  }, /*#__PURE__*/_react["default"].createElement(SelectedValuesComponent, {
    open: isOpen,
    value: value,
    inputValue: inputValue,
    onSubmit: onSubmit,
    onCancel: onCancel,
    onMenuOpen: onMenuOpen,
    onMenuClose: onMenuClose,
    onInputValueChange: handleInputValueChange,
    onSelectItemOn: handleSelectItemOn,
    onSelectItemOff: handleSelectItemOff
  })), /*#__PURE__*/_react["default"].createElement(_DropdownMenu["default"], {
    open: isOpen,
    style: {
      width: width
    }
  }, /*#__PURE__*/_react["default"].createElement(SuggestionsComponent, {
    open: isOpen,
    value: value,
    inputValue: inputValue,
    results: results,
    onCreate: onCreate,
    onMenuOpen: onMenuOpen,
    onMenuClose: onMenuClose,
    onInputValueChange: handleInputValueChange,
    onSelectItemOn: handleSelectItemOn,
    onSelectItemOff: handleSelectItemOff
  })));
};

Autocomplete.defaultProps = {
  onSubmit: function onSubmit() {},
  onCreate: function onCreate() {},
  onCancel: function onCancel() {},
  onChange: function onChange() {},
  onMenuOpen: function onMenuOpen() {},
  onMenuClose: function onMenuClose() {},
  onInputValueChange: function onInputValueChange() {},
  SelectedValuesComponent: SelectedValuesComponent,
  SuggestionsComponent: SuggestionsComponent
};
Autocomplete.propTypes = {
  inputValue: _propTypes["default"].string,
  value: _propTypes["default"].array,
  // array of objects { label, value }
  expanded: _propTypes["default"].bool
};
var _default = Autocomplete;
exports["default"] = _default;